import { css } from '@emotion/react'
import { Flow, HeadingSection } from 'bold-ui'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { useLoadImoveisInativacaoLazyQuery } from 'graphql/hooks.generated'
import { ImoveisQueryInput, TipoEnderecoEnum } from 'graphql/types.generated'
import { useEffect, useState } from 'react'
import { v4 } from 'uuid'

import { CardNovidadesInativacaoLoteImoveis } from './components/CardNovidadesInativacaoLoteImoveis'
import { InativacaoImoveisTable } from './components/InativacaoImoveisTable'
import { InativacaoImoveisBuscaForm } from './InativacaoImoveisBuscaForm'
import { InativacaoImoveisBuscaFormModel } from './model-inativacaoImoveis'

const FORA_DE_AREA = 'FA'
const INITIAL_VALUES: ImoveisQueryInput = {
  tipoEndereco: TipoEnderecoEnum.LOGRADOURO,
  stAtivo: true,
  pageParams: {
    page: 0,
    size: 10,
    sort: ['bairro', 'logradouro', 'numero', 'complemento', 'id'],
  },
}

export function InativacaoImoveisView() {
  const [imoveisInput, setImoveisInput] = useState<ImoveisQueryInput>(INITIAL_VALUES)
  const [resultadoVisivel, setResultadoVisivel] = useState(false)
  const [processingState, setProcessingState] = useState(false)
  const [progressToken, setProgressToken] = useState(v4())
  const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set())
  const [loadImoveis, { data, loading, refetch }] = useLoadImoveisInativacaoLazyQuery()

  useEffect(() => {
    if (resultadoVisivel) {
      loadImoveis({
        variables: { input: imoveisInput },
      })
    }
  }, [imoveisInput, loadImoveis, resultadoVisivel])

  const onBuscarImoveis = (formValues: InativacaoImoveisBuscaFormModel) => {
    const { unidadeSaude, equipe, microarea, ocultarImoveisComFamilia, ...values } = formValues

    const input = {
      ...values,
      tipoEndereco: TipoEnderecoEnum.LOGRADOURO,
      cnes: unidadeSaude?.cnes,
      ine: equipe?.ine,
      ocultarFamilias: ocultarImoveisComFamilia,
      microarea: microarea !== FORA_DE_AREA ? microarea : undefined,
      foraDeArea: microarea === FORA_DE_AREA,
      stAtivo: true,
      pageParams: {
        page: 0,
        size: 10,
        sort: ['bairro', 'logradouro', 'numero', 'complemento', 'id'],
      },
    }

    setImoveisInput(input)
    setResultadoVisivel(true)
    setProcessingState(false)
    setCheckedItems(new Set())
  }

  const onLimparCampos = () => {
    setImoveisInput(INITIAL_VALUES)
    setResultadoVisivel(false)
    setProcessingState(false)
    setCheckedItems(new Set())
  }

  const resetProcessingState = () => {
    setProcessingState(false)
    setProgressToken(v4())
  }

  return (
    <PageContent fluid type='filled'>
      <Breadcrumb title='Inativação de imóveis' />
      <HeadingSection level={1} title='Inativação de imóveis' />
      <Flow direction='vertical'>
        <CardNovidadesInativacaoLoteImoveis />
        <InativacaoImoveisBuscaForm
          onSubmit={onBuscarImoveis}
          onLimparCampos={onLimparCampos}
          disabled={processingState}
        />
        {resultadoVisivel && data?.imoveis && (
          <div css={styles.resultContainer}>
            <InativacaoImoveisTable
              pageResult={data.imoveis}
              loading={loading}
              setImoveisInput={setImoveisInput}
              refetch={() => refetch({ input: imoveisInput })}
              checkedItems={checkedItems}
              setCheckedItems={setCheckedItems}
              progressToken={progressToken}
              processingState={processingState}
              changeToProcessingState={() => setProcessingState(true)}
              resetProcessingState={resetProcessingState}
            />
          </div>
        )}
      </Flow>
    </PageContent>
  )
}

const styles = {
  resultContainer: css`
    margin-top: 56px;
  `,
}
